import { render, staticRenderFns } from "./MenuIcon.vue?vue&type=template&id=7fcb1a3c&scoped=true"
import script from "./MenuIcon.vue?vue&type=script&lang=js"
export * from "./MenuIcon.vue?vue&type=script&lang=js"
import style0 from "./MenuIcon.vue?vue&type=style&index=0&id=7fcb1a3c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fcb1a3c",
  null
  
)

export default component.exports